import styled from 'styled-components';

const UserDetailLayout = styled.div`
  .detail-user-icon:hover {
    color: #2e74ff;
  }

  .record-cover {
    max-height: 300px;
    overflow: scroll;
  }

  .input-search-phone {
    width: 300px;
  }

  .ant-pagination-item {
    display: none;
  }

  .table-input-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .input-search-phone {
      height: 40px;
    }

    .btn-refresh {
      background-color: white;
      color: #368fff;
      border: 1px solid #368fff;
      border-radius: 8px;
    }

    .btn-refresh-disabled {
      color: #dddede;
      border: 1px solid #dddede;
    }

    /* .custom-tooltip {
      border-radius: 22px;
    } */
  }

  .ant-pagination-options-size-changer.ant-select {
    margin-right: 0px;
  }
`;

export default UserDetailLayout;
